/* klaviyo-triggers.js
   Detecta clics en enlaces como #klaviyo:XbAxnJ y abre el popup correspondiente.
*/

(function () {
  // Espera a que el DOM esté listo
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href").trim();

    // Verifica si el enlace empieza con "#klaviyo:"
    if (href.startsWith("#klaviyo:")) {
      e.preventDefault();

      // Extrae el ID del formulario
      const formId = href.split("#klaviyo:")[1];

      if (formId) {
        // Ejecuta el trigger de Klaviyo (con reintento si la librería aún no cargó)
        function openForm(attempts) {
          attempts = attempts || 0;
          if (window._klOnsite && Array.isArray(window._klOnsite)) {
            try {
              window._klOnsite.push(["openForm", formId]);
              return;
            } catch (err) {}
          }
          if (attempts < 20) setTimeout(() => openForm(attempts + 1), 150);
        }

        openForm();
      }
    }
  });
})();


